import { render, staticRenderFns } from "./cateredProductOrder.vue?vue&type=template&id=02ee6e1a&scoped=true&"
import script from "./cateredProductOrder.vue?vue&type=script&lang=js&"
export * from "./cateredProductOrder.vue?vue&type=script&lang=js&"
import style0 from "./cateredProductOrder.vue?vue&type=style&index=0&id=02ee6e1a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ee6e1a",
  null
  
)

export default component.exports